import Vue from 'vue'
import sticky from '@/directives/sticky'
import privateAmount from '@/directives/private-amount'
import privateAmountAdvisory from '@/directives/private-amount-advisory'
import parallax from '@/directives/parallax-effect'

Vue.directive('sticky', sticky)
Vue.directive('privateAmount', privateAmount)
Vue.directive('privateAmountAdvisory', privateAmountAdvisory)
Vue.directive('parallax', parallax)
